//
import localizationConfig from "../config/localizationConfig";

// const DEFAULT_LANGUAGE = "AR"; // Set default language

// let currentLanguage = "";

// export const setLanguage = (lang = 'a') => {
//   currentLanguage = lang;
// };

export const getMessage = (key, lang) => {
  // console.log("language utils lang: ", lang);
  return lang ? localizationConfig[lang]?.messages[key] : key;
};

export const getOptions = (type, lang) => {
  return lang ? localizationConfig[lang]?.options[type] : [];
};
